"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[272,4825,5799],{

/***/ 272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ categoryPosts; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(2185);
// EXTERNAL MODULE: ./src/api/commonConstants.js
var commonConstants = __webpack_require__(96781);
// EXTERNAL MODULE: ./src/components/short-video/shortSlider.js
var shortSlider = __webpack_require__(35799);
// EXTERNAL MODULE: ./src/components/newsCard/newsTopbar/index.js
var newsTopbar = __webpack_require__(4825);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./src/components/newsCard/ReadNewsCardNew/index.js
var ReadNewsCardNew = __webpack_require__(43063);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/homePage/CategoryPosts/restCategory.js


 // import ReadNews from "components/newsCard/readNews";








var NewsImageTextBanner1 = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6677), __webpack_require__.e(5312)]).then(__webpack_require__.bind(__webpack_require__, 36677));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(36677)];
    }
  }
});

var RestCategory = function RestCategory(_ref) {
  var _newsData$slice, _newsData$slice2, _newsData$slice3, _newsData$slice4, _newsData$slice5, _newsData$slice6;

  var categoryInfo = _ref.categoryInfo,
      newsData = _ref.newsData;
  console.log("categoryInfo", categoryInfo);
  var router = (0,next_router.useRouter)();
  var size = (0,commonConstants/* useWindowSize */.iP)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [(categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.name) === "Entertainment" && router.pathname === "/" && size.width > 600 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container-row py-2",
      align: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        style: {
          fontSize: "11px",
          color: "#b7b7b7",
          marginBottom: "0px"
        },
        children: "Advertisement"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "div-gpt-ad-1701945220410-4",
        style: {
          minWidth: "300px",
          minHeight: "100px",
          display: "block !important",
          alignContent: "center",
          textAlign: "-webkit-center"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          type: "text/javascript",
          dangerouslySetInnerHTML: {
            __html: "\n          {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-4')})"
          }
        })
      })]
    }),  false && /*#__PURE__*/0, (categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.name) === "Sports" && router.pathname === "/text" && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container-row py-2",
      align: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        style: {
          fontSize: "11px",
          color: "#b7b7b7",
          marginBottom: "0px"
        },
        children: "Advertisement"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: size.width > 600 ? "div-gpt-ad-1701945220410-2" : "div-gpt-ad-1701946028239-1",
        style: {
          minWidth: "300px",
          minHeight: size.width > 600 ? "100px" : "260px",
          display: "block !important",
          alignContent: "center",
          textAlign: "-webkit-center"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          type: "text/javascript",
          dangerouslySetInnerHTML: {
            __html: size.width > 600 ? "\n          {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-2')})" : "\n          {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})"
          }
        })
      })]
    }), (categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.name) === "Lallankhas" && router.pathname !== "/" && size.width < 600 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container-row py-2",
      align: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        style: {
          fontSize: "11px",
          color: "#b7b7b7",
          marginBottom: "0px"
        },
        children: "Advertisement"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "div-gpt-ad-1701946028239-2",
        style: {
          minWidth: "300px",
          minHeight: "260px",
          display: "block !important",
          alignContent: "center",
          textAlign: "-webkit-center"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          type: "text/javascript",
          dangerouslySetInnerHTML: {
            __html: "\n          {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-2')})"
          }
        })
      })]
    }), (categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.name) === "Lallankhas" && router.pathname !== "/" && size.width > 600 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container-row py-2",
      align: "center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        style: {
          fontSize: "11px",
          color: "#b7b7b7",
          marginBottom: "0px"
        },
        children: "Advertisement"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        id: "div-gpt-ad-1701945220410-3",
        style: {
          minWidth: "300px",
          minHeight: "100px",
          display: "block !important",
          alignContent: "center",
          textAlign: "-webkit-center"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          type: "text/javascript",
          dangerouslySetInnerHTML: {
            __html: "\n          {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-3')})"
          }
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "outer-containers",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "content-container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "news-card-box",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(newsTopbar["default"], {
            newsEn: (categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.name) || "",
            newsHn: (categoryInfo === null || categoryInfo === void 0 ? void 0 : categoryInfo.nameHn) || "",
            newsIcon: "",
            newsBgclassName: "bar-bg-1",
            categoryInfo: categoryInfo // horizontalPosts={categorizedNews.horizontalPosts}
            // restPosts={categorizedNews.restPosts}

          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "content",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "left-area-Col",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {},
              children: newsData === null || newsData === void 0 ? void 0 : (_newsData$slice = newsData.slice(0, 1)) === null || _newsData$slice === void 0 ? void 0 : _newsData$slice.map(function (postData) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsImageTextBanner1, {
                    postData: postData,
                    hTag: 3
                  })
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })
            }), newsData === null || newsData === void 0 ? void 0 : (_newsData$slice2 = newsData.slice(1, 3)) === null || _newsData$slice2 === void 0 ? void 0 : _newsData$slice2.map(function (postData, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                className: "featuredCards",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReadNewsCardNew/* default */.Z, {
                  postData: postData,
                  isBanner: false
                }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
              }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "left-area-Col",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {},
              children: newsData === null || newsData === void 0 ? void 0 : (_newsData$slice3 = newsData.slice(3, 4)) === null || _newsData$slice3 === void 0 ? void 0 : _newsData$slice3.map(function (postData) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsImageTextBanner1, {
                    postData: postData,
                    hTag: 3
                  })
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })
            }), newsData === null || newsData === void 0 ? void 0 : (_newsData$slice4 = newsData.slice(4, 6)) === null || _newsData$slice4 === void 0 ? void 0 : _newsData$slice4.map(function (postData, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                className: "featuredCards",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReadNewsCardNew/* default */.Z, {
                  postData: postData,
                  isBanner: false
                }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
              }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "right-area-Col",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              style: {},
              children: newsData === null || newsData === void 0 ? void 0 : (_newsData$slice5 = newsData.slice(6, 7)) === null || _newsData$slice5 === void 0 ? void 0 : _newsData$slice5.map(function (postData) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsImageTextBanner1, {
                    postData: postData,
                    hTag: 3
                  })
                }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
              })
            }), newsData === null || newsData === void 0 ? void 0 : (_newsData$slice6 = newsData.slice(7, 9)) === null || _newsData$slice6 === void 0 ? void 0 : _newsData$slice6.map(function (postData, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Col/* default */.Z, {
                className: "featuredCards",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReadNewsCardNew/* default */.Z, {
                  postData: postData,
                  isBanner: false
                }, "index_".concat(index, "_").concat(postData === null || postData === void 0 ? void 0 : postData._id))
              }, "".concat(postData === null || postData === void 0 ? void 0 : postData._id));
            })]
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ var restCategory = (RestCategory);
;// CONCATENATED MODULE: ./src/components/homePage/CategoryPosts/categoryPosts.js














var Entertainment = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 3394).then(__webpack_require__.bind(__webpack_require__, 83394));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(83394)];
    }
  }
});
var FirstCategory = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 8590).then(__webpack_require__.bind(__webpack_require__, 28590));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(28590)];
    }
  }
}); // const RestCategory = dynamic(() => import("./restCategory.js", { ssr: true }));

var VisualStories = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 3586).then(__webpack_require__.bind(__webpack_require__, 63586));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(63586)];
    }
  }
});

var CategoryPosts = function CategoryPosts(_ref) {
  var _categoryPosts$, _categoryPosts$2;

  var _ref$NewsPageData = _ref.NewsPageData,
      NewsPageData = _ref$NewsPageData === void 0 ? [] : _ref$NewsPageData,
      _ref$shortsData = _ref.shortsData,
      shortsData = _ref$shortsData === void 0 ? [] : _ref$shortsData,
      _ref$topShowsWidgetDa = _ref.topShowsWidgetData,
      topShowsWidgetData = _ref$topShowsWidgetDa === void 0 ? [] : _ref$topShowsWidgetDa,
      _ref$topPodcastData = _ref.topPodcastData,
      topPodcastData = _ref$topPodcastData === void 0 ? [] : _ref$topPodcastData,
      _ref$authorWidgetData = _ref.authorWidgetData,
      authorWidgetData = _ref$authorWidgetData === void 0 ? [] : _ref$authorWidgetData;
  var dispatch = (0,es/* useDispatch */.I0)();
  var size = (0,commonConstants/* useWindowSize */.iP)(); // const isMobile = size.width < 500;

  var isDesktop = size.width >= 500;
  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    fetchCategoryPosts();
  }, []);

  var fetchCategoryPosts = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var requestOptions;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              requestOptions = {
                method: "GET",
                headers: {
                  "Content-Type": "application/json"
                }
              }; // console.log("Fetchcalled");

              _context.next = 3;
              return fetch("".concat("https://api.thelallantop.com", "/v2/web/home?type=").concat(router.pathname === "/" ? "video,text,liveblog" : router.pathname === "/text" ? "text" : "video", "&limit=12&skip=1&accessType=web"), requestOptions).then(function (response) {
                return response.json();
              }).then(function (data) {
                var _data$result;

                // const resArray = [...shortData, ...data?.result?.entities];
                // console.log("resArray", resArray, data?.result?.entities);
                // setShortData(resArray);
                dispatch({
                  type: "HOME_CATEGORY_POST",
                  //payload: { _id },
                  payload: {
                    categoryPosts: data === null || data === void 0 ? void 0 : (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.categoryPosts
                  } //payload: { payload: { _id } },

                });
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchCategoryPosts() {
      return _ref2.apply(this, arguments);
    };
  }();

  var categoryPosts = (0,es/* useSelector */.v9)(function (data) {
    return data.PostReducer.allCategoryHomePosts;
  });

  var _useState = (0,react.useState)(false),
      firstScroll = _useState[0],
      setFirstScroll = _useState[1];

  (0,react.useEffect)(function () {
    if (firstScroll === false) {
      var handleScroll = function handleScroll() {
        setFirstScroll(true);
        window.removeEventListener("scroll", handleScroll);
      };

      window.addEventListener("scroll", handleScroll);
    }
  }, [firstScroll]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FirstCategory, {
      categoryInfo: categoryPosts && ((_categoryPosts$ = categoryPosts[0]) === null || _categoryPosts$ === void 0 ? void 0 : _categoryPosts$.categoryInfo),
      newsData: categoryPosts && ((_categoryPosts$2 = categoryPosts[0]) === null || _categoryPosts$2 === void 0 ? void 0 : _categoryPosts$2.entities),
      topShowsWidgetData: topShowsWidgetData,
      topPodcastData: topPodcastData
    }), !router.pathname.includes("/text") && /*#__PURE__*/(0,jsx_runtime.jsx)(shortSlider["default"], {
      shortsData: shortsData,
      authorWidgetData: authorWidgetData
    }), categoryPosts === null || categoryPosts === void 0 ? void 0 : categoryPosts.slice(1).map(function (category, _) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(restCategory, {
          categoryInfo: category === null || category === void 0 ? void 0 : category.categoryInfo,
          newsData: category === null || category === void 0 ? void 0 : category.entities
        })
      });
    })]
  });
};

/* harmony default export */ var categoryPosts = (CategoryPosts);

/***/ }),

/***/ 4825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var localization_i8intl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54269);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);
 // import Link from "next/link";



 //import { useRouter } from "next/router";





var NewsTopbar = function NewsTopbar(props) {
  var _props$categoryInfo, _props$categoryInfo2, _props$newsEn, _props$categoryInfo3, _props$categoryInfo4, _props$newsEn2, _props$categoryInfo5, _props$categoryInfo6, _props$categoryInfo7, _props$categoryInfo8, _props$categoryInfo9, _props$categoryInfo10, _props$categoryInfo11, _props$categoryInfo12, _props$newsEn3;

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      language = _useState[0],
      setLanguage = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    setLanguage((0,localization_i8intl__WEBPACK_IMPORTED_MODULE_0__/* .getLanguage */ .G3)());
  }, []);
  var mainUrl = router !== null && router !== void 0 && router.pathname.includes("/video") ? "video/" : router !== null && router !== void 0 && router.pathname.includes("/text") ? "text/" : router !== null && router !== void 0 && router.pathname.includes("/audio") ? "audio/" : props.videoEn === "Top Shows" ? "show/all" : props.newsEn === "Polls" || props.videoEn === "Shorts" || props.videoEn === "Visual Stories" || props.videoEn === "Top Podcasts" ? "" : "";
  console.log("aaaaa", "/".concat(mainUrl).concat(props.videoEn === "Shorts" ? "short-video" : props.videoEn === "Visual Stories" ? "visualstories" : props.videoEn === "Top Shows" ? "" : (props === null || props === void 0 ? void 0 : (_props$categoryInfo = props.categoryInfo) === null || _props$categoryInfo === void 0 ? void 0 : _props$categoryInfo.slug) || (props === null || props === void 0 ? void 0 : (_props$categoryInfo2 = props.categoryInfo) === null || _props$categoryInfo2 === void 0 ? void 0 : _props$categoryInfo2.name.toLowerCase()) || (props === null || props === void 0 ? void 0 : (_props$newsEn = props.newsEn) === null || _props$newsEn === void 0 ? void 0 : _props$newsEn.toLowerCase()), "  ")); //console.log("props.newsE", mainUrl, props.videoEn);
  //const router = useRouter()
  // console.log("title==", props?.newsHn);
  // console.log("title1", props?.categoryInfo?.name);
  // console.log("title11", props?.categoryInfo?.nameHn);
  // console.log("title2", props?.videoHn);
  // console.log("title3", props?.newsEn);
  // const [videoShowClass, setVideoShowClass] = useState("");
  // console.log("newwews", props?.newsBgClass);
  // if (props?.newsBgClass === "videoShowTopBar")
  //   setVideoShowClass("videoShowTopBar");

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "news-top-bar ".concat(props === null || props === void 0 ? void 0 : props.newsBgClass) // style={{
      //   background:
      //     props?.newsBgclassName === "show" ||
      //     props?.newsBgclassName === "videoShow"
      //       ? "#FFFFFF"
      //       : props?.newsBgclassName === "topEpisode"
      //       ? "#6FCBD0"
      //       : `#${props?.categoryInfo?.headerColor || "61C777"}`,
      // }}
      ,
      style: {
        backgroundColor: "white"
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
        href: "/".concat(mainUrl).concat(props.videoEn === "Shorts" ? "short-video" : props.videoEn === "Visual Stories" ? "visualstories" : props.videoEn === "Top Shows" ? "" : props.videoEn === "Top Podcasts" ? "audio" : (props === null || props === void 0 ? void 0 : (_props$categoryInfo3 = props.categoryInfo) === null || _props$categoryInfo3 === void 0 ? void 0 : _props$categoryInfo3.slug) || (props === null || props === void 0 ? void 0 : (_props$categoryInfo4 = props.categoryInfo) === null || _props$categoryInfo4 === void 0 ? void 0 : _props$categoryInfo4.name.toLowerCase()) || (props === null || props === void 0 ? void 0 : (_props$newsEn2 = props.newsEn) === null || _props$newsEn2 === void 0 ? void 0 : _props$newsEn2.toLowerCase()), "  "),
        children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: "news-title-left ".concat(props === null || props === void 0 ? void 0 : props.videoTitleClass),
          style: {
            color: props.newsEn === "Polls" ? "#EB0E8C" : props.videoEn === "Shorts" || props.videoEn === "Visual Stories" || props.videoEn === "Top Podcasts" ? "#EB0E8C" : (props === null || props === void 0 ? void 0 : props.videoEn) === "Live Updates" ? "#6FCBD0" : (props === null || props === void 0 ? void 0 : props.newsEn) === "Top Shows" ? "#EB0E8C" : "#".concat((props === null || props === void 0 ? void 0 : (_props$categoryInfo5 = props.categoryInfo) === null || _props$categoryInfo5 === void 0 ? void 0 : _props$categoryInfo5.headerColor) || "61C777")
          },
          children: [(props === null || props === void 0 ? void 0 : props.newsEn) !== "Live Updates" && (props !== null && props !== void 0 && (_props$categoryInfo6 = props.categoryInfo) !== null && _props$categoryInfo6 !== void 0 && _props$categoryInfo6.image ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            style: {
              paddingRight: "10px",
              color: "#".concat((props === null || props === void 0 ? void 0 : (_props$categoryInfo7 = props.categoryInfo) === null || _props$categoryInfo7 === void 0 ? void 0 : _props$categoryInfo7.headerColor) || "61C777")
            },
            src: props === null || props === void 0 ? void 0 : (_props$categoryInfo8 = props.categoryInfo) === null || _props$categoryInfo8 === void 0 ? void 0 : _props$categoryInfo8.image // src={"/assets/images/Entertainment.png"}
            ,
            alt: "img",
            loading: "lazy",
            width: "32px",
            height: "32px"
          }) : props.newsIcon === "none" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {}) : (props === null || props === void 0 ? void 0 : props.newsIcon) === "videoShow" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("i", {
            className: "icon-play-circle"
          }) : props.newsIcon === "shorts" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: "/assets/images/Group 351.svg",
            style: {
              paddingRight: "10px"
            },
            width: "32px",
            height: "32px",
            loading: "lazy",
            alt: "home"
          }) : props.newsIcon === "podcast-wid" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: "https://static.thelallantop.com/images/post/1720689949626_vector_(8).webp" // style={{
            //   paddingRight: "10px",
            // }}
            ,
            width: "38px",
            height: "32px",
            loading: "lazy",
            alt: "home"
          }) : props.newsIcon === "visual-story" ? props !== null && props !== void 0 && props.isIpl ? null : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: "https://static.thelallantop.com/images/post/1719816698725_vector_(4).webp",
            style: {
              paddingRight: "10px"
            },
            width: "32px",
            height: "32px",
            loading: "lazy",
            alt: "home"
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("i", {
            className: "icon-news"
          })), (props === null || props === void 0 ? void 0 : props.newsEn) === "Live Updates" && !(props !== null && props !== void 0 && props.isIpl) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            style: {
              paddingRight: "10px"
            },
            src: "/assets/images/live_gif.gif",
            height: "32px",
            loading: "lazy",
            width: "32px" // src={"/assets/images/Entertainment.png"}
            ,
            alt: "img"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h2", {
            children: (props === null || props === void 0 ? void 0 : props.newsEn) === "Live Updates" ? language === "hi" ? props === null || props === void 0 ? void 0 : props.newsHn : props === null || props === void 0 ? void 0 : props.newsEn : language === "hi" ? (props === null || props === void 0 ? void 0 : (_props$categoryInfo9 = props.categoryInfo) === null || _props$categoryInfo9 === void 0 ? void 0 : _props$categoryInfo9.nameHn) || (props === null || props === void 0 ? void 0 : props.videoHn) || (props === null || props === void 0 ? void 0 : props.newsHn) : (props === null || props === void 0 ? void 0 : (_props$categoryInfo10 = props.categoryInfo) === null || _props$categoryInfo10 === void 0 ? void 0 : _props$categoryInfo10.name) || (props === null || props === void 0 ? void 0 : props.videoEn) || (props === null || props === void 0 ? void 0 : props.newsEn)
          })]
        })]
      }), (props === null || props === void 0 ? void 0 : props.newsHn) === "featured" || (props === null || props === void 0 ? void 0 : props.newsHn) === "फीचर्ड" || (props === null || props === void 0 ? void 0 : props.newsHn) === "Top Show" || (props === null || props === void 0 ? void 0 : props.newsHn) === "Featured" || (props === null || props === void 0 ? void 0 : props.newsHn) === "टॉप शो" || (props === null || props === void 0 ? void 0 : props.newsHn) === "फीचर्ड" ? "" : (props === null || props === void 0 ? void 0 : props.newsIcon) === "videoShow" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
        className: "news-link ".concat(props === null || props === void 0 ? void 0 : props.videoLinkClass),
        href: "/show/all",
        style: {
          color: (props === null || props === void 0 ? void 0 : props.newsBgclassName) === "videoShow" && "#5F5F5F",
          marginTop: "0.6rem"
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          style: {
            color: "rgb(95, 95, 95)"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            id: "see_more",
            defaultMessage: "\u0914\u0930 \u0926\u0947\u0916\u0947\u0902"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("i", {
          className: "icon-arrow-right",
          style: {
            color: "gray"
          }
        })]
      }) : (props === null || props === void 0 ? void 0 : props.newsIcon) === "shorts" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
          className: "news-link ".concat(props === null || props === void 0 ? void 0 : props.videoLinkClass),
          href: "/short-video",
          style: {
            color: (props === null || props === void 0 ? void 0 : props.newsBgclassName) === "videoShow" && "#5F5F5F",
            marginTop: "0.6rem"
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              id: "see_more",
              defaultMessage: "\u0914\u0930 \u0926\u0947\u0916\u0947\u0902"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("i", {
            className: "icon-arrow-right",
            style: {
              color: "gray"
            }
          })]
        })]
      }) : (props === null || props === void 0 ? void 0 : props.newsIcon) === "visual-story" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
          className: "".concat(props === null || props === void 0 ? void 0 : props.videoLinkClass),
          href: props !== null && props !== void 0 && props.isIpl ? "/visualstories/sports" : "/visualstories",
          style: {
            color: (props === null || props === void 0 ? void 0 : props.newsBgclassName) === "videoShow" && "#5F5F5F",
            marginTop: "0.6rem"
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              id: "see_more",
              defaultMessage: "\u0914\u0930 \u0926\u0947\u0916\u0947\u0902"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("i", {
            className: "icon-arrow-right",
            style: {
              color: "gray"
            }
          })]
        })]
      }) : (props === null || props === void 0 ? void 0 : props.newsIcon) === "podcast-wid" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: [" ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
          className: "news-link ".concat(props === null || props === void 0 ? void 0 : props.videoLinkClass),
          href: "/audio",
          style: {
            color: (props === null || props === void 0 ? void 0 : props.newsBgclassName) === "videoShow" && "#5F5F5F",
            marginTop: "0.6rem"
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              id: "see_more",
              defaultMessage: "\u0914\u0930 \u0926\u0947\u0916\u0947\u0902"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("i", {
            className: "icon-arrow-right",
            style: {
              color: "gray"
            }
          })]
        })]
      }) : (props === null || props === void 0 ? void 0 : props.newsEn) !== "Live Updates" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("a", {
        className: "news-link ".concat(props === null || props === void 0 ? void 0 : props.videoLinkClass),
        href: "/".concat(mainUrl === "" ? "" : mainUrl + "/").concat((props === null || props === void 0 ? void 0 : (_props$categoryInfo11 = props.categoryInfo) === null || _props$categoryInfo11 === void 0 ? void 0 : _props$categoryInfo11.slug) || (props === null || props === void 0 ? void 0 : (_props$categoryInfo12 = props.categoryInfo) === null || _props$categoryInfo12 === void 0 ? void 0 : _props$categoryInfo12.name.toLowerCase()) || (props === null || props === void 0 ? void 0 : (_props$newsEn3 = props.newsEn) === null || _props$newsEn3 === void 0 ? void 0 : _props$newsEn3.toLowerCase())),
        style: {
          color: (props === null || props === void 0 ? void 0 : props.newsBgclassName) === "videoShow" && "#5F5F5F"
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          style: {
            color: "#5F5F5F"
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            id: "see_more",
            defaultMessage: "\u0914\u0930 \u0926\u0947\u0916\u0947\u0902"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("i", {
          className: "icon-arrow-right",
          style: {
            color: "gray"
          }
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (NewsTopbar);

/***/ }),

/***/ 35799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2185);
/* harmony import */ var redux_actions_shortsAction__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31284);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96781);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30719);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(965);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50094);
/* harmony import */ var swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_free_mode__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);
 // import { baseUrl } from "api/constants";

 // import { Col } from "react-bootstrap";
// import Image from "next/image";



 // import AuthorColumn from "./../homePage/authorColumn";


var NewsTopbar = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return __webpack_require__.e(/* import() */ 4825).then(__webpack_require__.bind(__webpack_require__, 4825));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(4825)];
    }
  }
});

 // Import Swiper styles



 // import "swiper/modules/navigation/navigation.scss"; // Navigation module
// import "swiper/modules/free-mode/free-mode.scss"; // Pagination module





var StoryCard = function StoryCard(_ref) {
  var storyData = _ref.storyData,
      storyShowData = _ref.storyShowData,
      setLoginPrompt = _ref.setLoginPrompt,
      _ref$postType = _ref.postType,
      postType = _ref$postType === void 0 ? "story" : _ref$postType;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
    className: "",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: "" // onClick={() => {
      //   router.push(`/short-video/${storyData?.postSlug}`);
      //   //   handleClick(story);
      //   //   handleView(story?._id);
      // }}
      ,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("a", {
        href: "/short-video/".concat(storyData === null || storyData === void 0 ? void 0 : storyData.postSlug),
        passHref: true,
        children: [" ", (storyData === null || storyData === void 0 ? void 0 : storyData.headingImageUrl) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
          src: (storyData === null || storyData === void 0 ? void 0 : storyData.headingImageUrl) + "?width=190",
          alt: "Story image",
          className: "short-slider-image-customstyle",
          loading: "lazy",
          style: {
            borderRadius: "4px"
          },
          height: 268
        })]
      })
    })
  });
};

var ShortsSlider = function ShortsSlider(_ref2) {
  var _ref2$shortsData = _ref2.shortsData,
      shortsData = _ref2$shortsData === void 0 ? [] : _ref2$shortsData,
      _ref2$atOlympicsPage = _ref2.atOlympicsPage,
      atOlympicsPage = _ref2$atOlympicsPage === void 0 ? false : _ref2$atOlympicsPage,
      _ref2$authorWidgetDat = _ref2.authorWidgetData,
      authorWidgetData = _ref2$authorWidgetDat === void 0 ? [] : _ref2$authorWidgetDat;
  var prevRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var nextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(shortsData),
      shortData = _useState[0],
      setShortData = _useState[1];

  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_4__/* .useWindowSize */ .iP)();
  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true),
      isBeginning = _useState2[0],
      setIsBeginning = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isEnd = _useState3[0],
      setIsEnd = _useState3[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    dispatch((0,redux_actions_shortsAction__WEBPACK_IMPORTED_MODULE_11__/* .saveShortList */ .J)(shortData));
  }, [shortData]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
      className: "outer-main-conainer",
      style: {
        marginTop: "1.5rem",
        marginBottom: "1.5rem",
        borderRadius: "12px"
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
        className: "".concat(atOlympicsPage ? "news-card-body-olympic" : "main-containerTopShow show-widget-alignment"),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: "home-left-align-short",
          style: {
            width: authorWidgetData && authorWidgetData.length > 0 && size.width > 1024 ? "67%" : "100%"
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            className: "topShowsTopBar",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(NewsTopbar, {
              videoEn: "Shorts",
              videoHn: "शॉर्ट्स",
              newsIcon: "shorts",
              newsBgclassName: "videoShow",
              newsBgClass: "videoShowTopBar",
              videoTitleClass: "videoTitle",
              videoImgClass: "videoImg",
              videoLinkClass: "videoLink"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            className: "checkMobileOrNot",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              className: "scrollbarX",
              style: {
                minHeight: "30.7rem"
              },
              children: shortData === null || shortData === void 0 ? void 0 : shortData.map(function (data, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                    className: "stories-items",
                    style: {
                      width: "18.9rem",
                      height: "34.7rem",
                      marginRight: "1rem"
                    },
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(StoryCard, {
                      storyData: data
                    })
                  })
                }, "index_".concat(index, "_").concat(data === null || data === void 0 ? void 0 : data._id));
              })
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            className: "checkDesktopOrNot",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.Fragment, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
                breakpoints: {
                  0: {
                    slidesPerView: 1
                  },
                  400: {
                    slidesPerView: 3.5
                  },
                  639: {
                    slidesPerView: 3.7
                  },
                  865: {
                    slidesPerView: 3.9
                  },
                  1000: {
                    slidesPerView: 4.2
                  },
                  1025: {
                    slidesPerView: (authorWidgetData === null || authorWidgetData === void 0 ? void 0 : authorWidgetData.length) > 0 ? 4 : 6
                  },
                  1350: {
                    slidesPerView: (authorWidgetData === null || authorWidgetData === void 0 ? void 0 : authorWidgetData.length) > 0 ? 4.5 : 6
                  },
                  1500: {
                    slidesPerView: (authorWidgetData === null || authorWidgetData === void 0 ? void 0 : authorWidgetData.length) > 0 ? 5 : 7
                  },
                  1700: {
                    slidesPerView: (authorWidgetData === null || authorWidgetData === void 0 ? void 0 : authorWidgetData.length) > 0 ? 5.4 : 7
                  }
                },
                spaceBetween: 16,
                freeMode: true // navigation={true}
                ,
                pagination: {
                  clickable: true
                },
                onInit: function onInit(swiper) {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                  console.log(prevRef.current);
                  console.log(nextRef.current);
                  swiper.on("slideChange", function () {
                    setIsBeginning(swiper.isBeginning);
                    setIsEnd(swiper.isEnd);
                  });
                  swiper.navigation.init();
                  swiper.navigation.update();
                },
                modules: [swiper__WEBPACK_IMPORTED_MODULE_6__/* .FreeMode */ .Rv, swiper__WEBPACK_IMPORTED_MODULE_6__/* .Navigation */ .W_],
                className: "mySwiper shorts-slider",
                children: [shortData === null || shortData === void 0 ? void 0 : shortData.map(function (data, index) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
                    index: index,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                      index: index,
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("a", {
                        href: "/short-video/".concat(data === null || data === void 0 ? void 0 : data.postSlug),
                        index: index,
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("img", {
                          className: "short-slider-img",
                          src: data === null || data === void 0 ? void 0 : data.headingImageUrl
                        })
                      })
                    })
                  }, index);
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                  className: "shorts-slider-button-bwd",
                  style: !isBeginning ? {
                    display: "block"
                  } : {
                    display: "none"
                  },
                  ref: prevRef,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                    children: "<"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                  className: "shorts-slider-button-fwd",
                  style: !isEnd ? {
                    display: "block"
                  } : {
                    display: "none"
                  },
                  ref: nextRef,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                    children: ">"
                  })
                })]
              })
            })
          })]
        }), size.width <= 499 && !atOlympicsPage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
          className: "gray-home-seperator"
        }), size.width >= 499 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          style: {
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: "12px"
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              marginBottom: "0px"
            },
            children: "Advertisement"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            id: "div-gpt-ad-1701945220410-3",
            style: {
              minWidth: "300px",
              minHeight: "100px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: "\n          {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-3')})"
              }
            })
          })]
        }), size.width < 499 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              marginBottom: "0px"
            },
            children: "Advertisement"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            id: "div-gpt-ad-1701946028239-3",
            style: {
              minWidth: "300px",
              minHeight: "100px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: "\n          {googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-3')})"
              }
            })
          })]
        })]
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ShortsSlider);

/***/ }),

/***/ 31284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ saveShortList; }
/* harmony export */ });
/* harmony import */ var redux_actionTypes_shorts_ActionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67644);

var saveShortList = function saveShortList(payload) {
  return {
    type: redux_actionTypes_shorts_ActionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SHORT_LIST_INIT */ .T,
    payload: payload
  };
};

/***/ })

}]);